export default {
  notes: (state) => state.notes,
  loading: (state) => state.loading,
}
